// @ts-strict-ignore
import { Pipe, PipeTransform } from '@angular/core';
import { ClientParameter } from '../../../model/client-model/client-parameter';

@Pipe({
    name: 'normalisedParameterValue',
    pure: true,
    standalone: false
})
export class NormalisedParameterValuePipe implements PipeTransform {
  transform(value: ClientParameter, population?: number): number {
    switch (value.approximationType) {
      case 'constant':
        return value.approximation;
      case 'perCapita':
        return Number((value.approximation * population).toPrecision(6));
    }
  }
}
